import React, { useRef, useState, useEffect } from 'react';
import { buildBackendImgUrl } from '../../../utils/api';
import { CardLink, CardArticle, TitleBar, TitleAvatar, TitleText, VendidoRibbon  } from './Cargaimg.styles';
import AdaptiveGrid from '../../ImageGrid/AdaptiveGrid';

function Cargaimg({ task, showDestacado = false }) {
  const cardRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(null);

  useEffect(() => {
    if (!cardRef.current) return;
    const update = () => setCardWidth(Math.round(cardRef.current.offsetWidth));
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  const imgs   = [task.Imagen1, task.Imagen2, task.Imagen3, task.Imagen4];
  const thumbs = [
    task.Thumb1 || task.Imagen1,
    task.Thumb2 || task.Imagen2,
    task.Thumb3 || task.Imagen3,
    task.Thumb4 || task.Imagen4,
  ];
 
  let currentUserId = null;
  try {
    const stored = localStorage.getItem('user');
    if (stored) currentUserId = JSON.parse(stored).id;
  } catch {}

  const isOwner = currentUserId && Number(task.usuario_id) === Number(currentUserId);
  const linkTo  = isOwner ? '/mi-trastero' : `/de/${task.trastero_nombre}`;

  return (
    <CardLink to={linkTo}>
      <CardArticle ref={cardRef} style={showDestacado && task.destacado ? { boxShadow: '0 0 0 2px #f5c518', borderRadius: 8 } : undefined}>
          {task.vendido && <VendidoRibbon>VENDIDO</VendidoRibbon>}
        {showDestacado && task.destacado && (
          <div style={{
            position: 'absolute', top: 4, right: 4, zIndex: 10,
            background: '#f5c518', color: '#1a1a1a',
            fontSize: 10, fontWeight: 700, padding: '2px 6px',
            borderRadius: 4, lineHeight: 1.4, pointerEvents: 'none',
          }}>⭐ DESTACADO</div>
        )}
        <TitleBar>
          <TitleAvatar
            src={buildBackendImgUrl(task.foto_trastero) || `${buildBackendImgUrl(task.Ruta)}/${task.Thumb1 || task.Imagen1}`}
            alt={task.trastero_nombre || task.Nombre}
            loading="lazy"
            onError={e => { e.target.onerror = null; e.target.src = '/placeholder.jpg'; }}
          />
          <TitleText>{task.trastero_nombre || task.Nombre}</TitleText>
        </TitleBar>
        <AdaptiveGrid ruta={buildBackendImgUrl(task.Ruta)} imgs={imgs} thumbs={thumbs} width="100%" />
      </CardArticle>
    </CardLink>
  );
}

export default Cargaimg;
